import { useState, useEffect } from "react";
import { ConfigProvider, theme } from "antd";
import AppRoutes from "./components/routes/AppRoutes";
import Loader from "./components/loader/Loader";
import AppVersionModal from "./components/appVersionModal/AppVersionModal";
import { useAppVersion } from "./components/hooks/useAppVersion";
import { useAuth } from "./AuthContext";

const App = () => {
  const { loading, loggedUser } = useAuth();
  const appVersion = useAppVersion();

  const { showUpdateModal, handleUpdate } = appVersion;

  const [darkMode, setDarkMode] = useState(() => {
    const stored = localStorage.getItem("theme");
    return stored ? stored === "dark" : true;
  });

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [darkMode]);

  useEffect(() => {
    localStorage.setItem("theme", darkMode ? "dark" : "light");
  }, [darkMode]);

  if (loading) {
    return <Loader />;
  }

  return (
    <ConfigProvider
      theme={{
        algorithm: darkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
        token: {
          colorPrimary: "#FB9A1A",
          fontFamily: "Roboto Condensed, Ubuntu, sans-serif",
          fontSize: 15,
          fontSizeHeading1: 39,
          fontSizeHeading2: 31,
          fontSizeHeading3: 25,
          fontSizeHeading4: 21,
          fontSizeHeading5: 17,
        },
      }}
    >
      {/* Modal de actualización - Se renderiza siempre pero solo se muestra cuando es necesario */}
      <AppVersionModal visible={showUpdateModal} onConfirm={handleUpdate} />
      <div
        style={{
          filter: showUpdateModal ? "blur(4px)" : "none",
          pointerEvents: showUpdateModal ? "none" : "auto",
        }}
      >
        <AppRoutes
          darkMode={darkMode}
          setDarkMode={setDarkMode}
          loggedUser={loggedUser}
        />
      </div>
    </ConfigProvider>
  );
};

export default App;
